import React from 'react'
import moment from 'moment'
import { colors, SectionTitle } from '@diversioteam/diversio-ds'

import { getTimeAgo } from './publishedStatus.helpers'
import { PublishedStatusProps } from './publishedStatus.types'
import * as S from './publishedStatus.styles'

export const PublishedStatus = ({ publishDate, closeDate }: PublishedStatusProps) => {
    const isClosed = closeDate !== null

    const status = isClosed ? 'closed' : 'live'
    const date = isClosed ? closeDate : publishDate

    const formattedDate = date ? moment(date).format('MMM DD, YYYY') : 'N/A'

    return (
        <S.PublishedStatusWrapper>
            <S.Header>
                <SectionTitle text={status} icon={null} />

                <S.StatusIcon type="line" color={isClosed ? colors.secondary200 : colors.green50} />
            </S.Header>

            <S.DateInfo>
                <span>
                    {isClosed ? 'Closed on' : 'Published on'} {formattedDate}
                </span>

                <span>{getTimeAgo(date)}</span>
            </S.DateInfo>
        </S.PublishedStatusWrapper>
    )
}
